import { render, staticRenderFns } from "./RightNav.vue?vue&type=template&id=04006e74&scoped=true&"
import script from "./RightNav.vue?vue&type=script&lang=js&"
export * from "./RightNav.vue?vue&type=script&lang=js&"
import style0 from "./RightNav.vue?vue&type=style&index=0&id=04006e74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04006e74",
  null
  
)

export default component.exports